import React from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
} from "mdb-react-ui-kit";

import "./Faq.css";

export default function FaqMed() {
  return (
    <MDBContainer className="mt-4">
      <section>
        <h3 className="text-center mb-2 pb-2 text-primary fw-bold">FAQ</h3>
        <p
          className="text-center mb-4
        "
        >
          Find the answers to the most frequently asked questions below.
        </p>

        <MDBRow>

        <MDBCol md="6" lg="4" className="mb-4">
            <MDBCard className="faq-card">
              <MDBCardBody>
                <h6 className="mb-3">
                  Can I tune after making patch with your site?
                </h6>
                <p>
                  <strong>
                    <u>Yes, </u>
                  </strong>
                  You can tune as you like.
                </p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

          <MDBCol md="6" lg="4" className="mb-4">
            <MDBCard className="faq-card">
              <MDBCardBody>
                <h6 className="mb-3">
                  Which File do I use with tool?
                </h6>
                <p>
                  File must be full read or bench/boot read.VR is not supported.
                </p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

          
          <MDBCol md="6" lg="4" className="mb-4">
            <MDBCard className="faq-card">
              <MDBCardBody>
                <h6 className="mb-3">
                  Is 2.5MB RS3 MED9 supported?
                </h6>
                <p>
                  <strong>
                    <u>Yes!</u>
                  </strong>
                </p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

          <MDBCol md="6" lg="4" className="mb-4">
            <MDBCard className="faq-card">
              <MDBCardBody>
                <h6 className="mb-3">
                  Can more maps be switched?
                </h6>
                <p>
                  <strong>No, </strong>
                  Only these are supported.
                </p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

          <MDBCol md="6" lg="4" className="mb-4">
            <MDBCard className="faq-card">
              <MDBCardBody>
                <h6 className="mb-3">
                  Can Immo be turned off?
                </h6>
                <p>
                  <strong>No! </strong>
                </p>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </section>
    </MDBContainer>
  );
}
